import { Form } from "antd";
import styled from "styled-components";

export const FormItemBold = styled(Form.Item)`
  .ant-form-item-label {
    font-weight: bold;
  }
`;
